import { brandPrimary, inputBorderColor, titles } from '../../../../web/styles/colors';
import { BreakPoints, CssSelectors, ctaButtonBase } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

const headerHeight = 35;
const subheaderHeight = 35;
const contentPadding = 20;
const contextContainerWidth = 360;

export const styleSheet = StyleSheet.create({
	additionalControlsContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		padding: '0 20px 20px',
	},
	adminNoteModal: {
		...CssSelectors.allDescendants(
			{
				padding: '0 20px',
			},
			'.cc-field-token-container'
		),
	},
	adminNoteModalCCOpen: {
		borderTop: 'none',
		...CssSelectors.allDescendants(
			{
				borderBottom: '1px solid rgb(204, 204, 204)',
				paddingBottom: 12,
			},
			'.cc-field'
		),
		...CssSelectors.allDescendants(
			{
				marginLeft: 0,
			},
			'.dropdown'
		),
	},
	body: {
		display: 'flex',
		height: `calc(100% - ${headerHeight}px)`,
	},
	container: {
		height: 630,
		minHeight: 300,
		minWidth: 900,
		position: 'relative',
		[BreakPoints.tabletHeight]: {
			height: '80vh',
		},
	},
	editor: {
		borderTop: `1px ${inputBorderColor} solid`,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingBottom: contentPadding,
		...CssSelectors.allDescendants(
			{
				flexGrow: 1,
			},
			'.note-editor-body'
		),
	},
	editorContainer: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		height: '100%',
	},
	editorContext: {
		borderLeft: `1px ${inputBorderColor} solid`,
		boxSizing: 'border-box',
		height: '100%',
		overflowY: 'auto',
		padding: 30,
		width: contextContainerWidth,
	},
	editorFooter: {
		padding: `0 ${contentPadding}px`,
		...CssSelectors.allDescendants(
			{
				...ctaButtonBase,
			},
			'.note-editor-save-button'
		),
	},
	header: {
		alignItems: 'center',
		background: brandPrimary,
		display: 'flex',
		height: headerHeight,
		justifyContent: 'space-between',
		padding: `0 ${contentPadding}px`,
	},
	modal: {
		...CssSelectors.allChildren(
			{
				...CssSelectors.allChildren(
					{
						padding: 0,
					},
					'.modal-overlay-content'
				),
			},
			'.modal-overlay'
		),
	},
	subheader: {
		color: titles,
		fontSize: 18,
		height: subheaderHeight,
		padding: contentPadding,
	},
});
